import React, { useRef, useState } from 'react';
import Alert from 'react-bootstrap/Alert';
import { ChevronDown } from 'lucide-react';

const Result = ({ email }) => {
    return (
        <Alert variant="success" className="success-msg">
            Your application has been successfully sent
        </Alert>
    );
};

const FormCareers = () => {
    const form = useRef();
    const [result, showResult] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [selectedPosition, setSelectedPosition] = useState('Facilities Engineer');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState(null);

    const positions = [
        "Facilities Engineer",
        "House Keeping Supervisor",
        "Facilities Manager",
        "Business Development Manager",
        "HR",
        "Admin",
        "Accounts Officer",
        "Procurement Officer",
        "CAFM Operator"
    ];

    const handleSelect = (position) => {
        setSelectedPosition(position);
        setIsOpen(false);
    };

    const sendApplication = async (formData) => {
        try {
            setIsSubmitting(true);
            setError(null);
            
            const response = await fetch('https://ucwf-server-42s2.onrender.com/api/application/career', {
                method: 'POST',
                body: formData
                // Don't set Content-Type header when sending FormData, 
                // the browser will set it automatically with the correct boundary
            });

            if (!response.ok) {
                throw new Error(`Server responded with status ${response.status}`);
            }

            const data = await response.json();
            return data;
        } catch (err) {
            console.error('Error submitting application:', err);
            throw err;
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        const formData = new FormData();
        formData.append('name', form.current['contact-name'].value);
        formData.append('email', form.current['contact-email'].value);
        formData.append('contact', form.current['contact-phone'].value);
        formData.append('position', selectedPosition);
        
        // Append the CV file
        const cvFile = form.current['contact-cv'].files[0];
        if (cvFile) {
            formData.append('cv', cvFile);
        }

        try {
            await sendApplication(formData);
            form.current.reset();
            setSelectedPosition('Facilities Engineer');
            showResult(true);
            
            // Hide success message after 5 seconds
            setTimeout(() => {
                showResult(false);
            }, 5000);
        } catch (err) {
            setError('Failed to submit application. Please try again.');
        }
    };

    return (
        <form ref={form} onSubmit={handleSubmit} className="axil-contact-form" encType="multipart/form-data">
            <div className="form-group">
                <label htmlFor="name">Name</label>
                <input type="text" className="form-control" name="contact-name" required />
            </div>
            <div className="form-group">
                <label htmlFor="email">Email</label>
                <input type="email" className="form-control" name="contact-email" required />
            </div>
            <div className="form-group">
                <label htmlFor="phone">Contact Number</label>
                <input type="tel" className="form-control" name="contact-phone" required />
            </div>
            <div className="form-group">
                <label>Position</label>
                <div className="ucwf-dropdown">
                    <input 
                        type="hidden" 
                        name="contact-position" 
                        value={selectedPosition} 
                    />
                    <div className="ucwf-dropdown-header" onClick={() => setIsOpen(!isOpen)}>
                        <span>{selectedPosition}</span>
                        <button type="button" className="ucwf-dropdown-button">
                            <ChevronDown size={20} />
                        </button>
                    </div>
                    {isOpen && (
                        <div className="ucwf-dropdown-menu">
                            {positions.map((position) => (
                                <div
                                    key={position}
                                    className="ucwf-dropdown-item"
                                    onClick={() => handleSelect(position)}
                                >
                                    {position}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
            <div className="form-group">
                <label htmlFor="cv">CV</label>
                <input 
                    type="file" 
                    className="form-control" 
                    name="contact-cv" 
                    accept=".pdf,.doc,.docx" 
                    required 
                />
            </div>
            <div className="form-group">
                <button 
                    type="submit" 
                    className="axil-btn btn-fill-primary btn-fluid btn-primary" 
                    name="submit-btn"
                    disabled={isSubmitting}
                >
                    {isSubmitting ? 'Submitting...' : 'Submit Application'}
                </button>
            </div>
            <div className="form-group">
                {error && <Alert variant="danger">{error}</Alert>}
                {result ? <Result email="our recruitment team" /> : null}
            </div>
        </form>
    );
};

export default FormCareers;